var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.496,
    height: 16.484,
    viewBox: "0 0 16.496 16.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 16.496,
    height: 16.484,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M210.462,0c.164.1.32.222.323.433V5.52a1.462,1.462,0,1,1-.967-1.562v-1.9l-3.88.77-.017,3.715a1.462,1.462,0,1,1-.962-1.622V1.3a.584.584,0,0,1,.372-.336L210.108,0Z",
    transform: "translate(-194.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M.019,95.949A6.447,6.447,0,0,1,.131,95.3,6.361,6.361,0,0,1,8.74,90.736c.051.057-.219.229-.259.272a2.4,2.4,0,0,0,3.382,3.414c.04-.038.229-.328.288-.275a6.366,6.366,0,0,1-4.595,8.614A6.377,6.377,0,0,1,.019,97.14a9.254,9.254,0,0,1,0-1.191m6.2-3.724a4.38,4.38,0,0,0-4.243,4.289.482.482,0,0,0,.772.415c.264-.2.164-.475.2-.738a3.44,3.44,0,0,1,2.98-3.005c.145-.017.3.012.439-.012a.48.48,0,1,0-.143-.949M7.76,96.56a1.434,1.434,0,1,0-1.434,1.434A1.434,1.434,0,0,0,7.76,96.56m2.388-.475c-.54.046-.422.723-.485,1.095a3.448,3.448,0,0,1-2.693,2.713,2.994,2.994,0,0,0-.895.135.476.476,0,0,0,.238.875,4.4,4.4,0,0,0,4.356-4.3.514.514,0,0,0-.523-.523",
    transform: "translate(0 -86.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M136.705,225.592a.492.492,0,1,1-.492-.492.492.492,0,0,1,.492.492",
    transform: "translate(-129.888 -215.423)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundLibrary);
export default __webpack_public_path__ + "static/media/soundLibrary.57b98679dbf44e331e7c1f9cbaf4f60f.svg";
export { ForwardRef as ReactComponent };